import { useState } from "react";
import { Link as RouterLink } from "react-router";
import {
    Alert, Box, Button, Card, FormControl, FormLabel, Input, Link, Stack, Typography,
} from "@mui/joy";
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';

import { APIPartnerRequestPasswordReset } from "../../api_partner_auth";
import { NAME_PROJECT } from "../../utils";


export default function PartnerForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState(null);

    const submit = async () => {
        setError(null);
        if (!email) { setError('Введите email'); return; }
        try {
            setLoading(true);
            await APIPartnerRequestPasswordReset(email);
            setSent(true);
        } catch (e) {
            setError(e?.response?.data?.error || 'Не удалось отправить запрос');
        } finally { setLoading(false); }
    };

    return (
        <Box sx={{
            minHeight: '100vh',
            display: 'flex', flexDirection: 'column',
            justifyContent: 'center', alignItems: 'center',
            px: 2, py: 4,
            background: (theme) => `linear-gradient(145deg, ${theme.vars.palette.primary[50]} 0%, #ffffff 100%)`,
        }}>
            <Stack direction="column" alignItems="center" spacing={1} sx={{ mb: 3 }}>
                <Typography level="h3" sx={{ fontWeight: 'bold', color: 'primary.700' }}>
                    Кабинет партнёра
                </Typography>
                <Typography level="body-sm" color="neutral">{NAME_PROJECT}</Typography>
            </Stack>

            <Card sx={{ width: '100%', maxWidth: 420, p: 3, borderRadius: 'xl', boxShadow: 'lg' }}>
                <Typography level="title-lg" sx={{ mb: 0.5 }}>Восстановление пароля</Typography>
                <Typography level="body-sm" color="neutral" sx={{ mb: 2 }}>
                    Укажите email, на который зарегистрирован партнёрский аккаунт
                </Typography>

                {error && <Alert color="danger" sx={{ mb: 1.5 }}>{error}</Alert>}

                {sent ? (
                    <Alert color="success" sx={{ mb: 1.5 }}>
                        Если такой email зарегистрирован — инструкции отправлены. Проверьте почту (и папку «Спам»).
                    </Alert>
                ) : (
                    <Stack spacing={1.5}>
                        <FormControl>
                            <FormLabel>Email</FormLabel>
                            <Input
                                type="email"
                                startDecorator={<EmailRoundedIcon />}
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                placeholder="partner@email.com"
                                onKeyDown={e => e.key === 'Enter' && submit()}
                            />
                        </FormControl>
                        <Button onClick={submit} loading={loading} size="lg">
                            Отправить инструкции
                        </Button>
                    </Stack>
                )}

                <Box sx={{ mt: 2, textAlign: 'center' }}>
                    <Link
                        component={RouterLink}
                        to="/partner/login"
                        level="body-sm"
                        startDecorator={<ArrowBackRoundedIcon fontSize="small" />}
                    >
                        Вернуться к входу
                    </Link>
                </Box>
            </Card>
        </Box>
    );
}